require("./itemDetailsInventory.less");
import {LoDashStatic} from "lodash";

const _ = <LoDashStatic> require('lodash');

class ItemDetailsInventoryController {
    inventory;
    stockUpdateFunc;

    toolbarheaderDefinition = {
        isTable: true,
        previousStateArrowActive: true,
        toolbarHeading: "",
    };

    tableDefinition = {
        settings: {
            promise: null,
            hideToolbar: true,
            hidePaginator: true,
            editFunction: (ev, row) => this.editFifo(ev, row)
        },
        columns: [
            {title: 'Lokasjon', name: 'locationId', noOrderBy: true},
            {title: 'Eldste dato', name: 'oldestDate', type: 'date', dateFormat: 'dd.MM.yyyy', noOrderBy: true},
            {title: 'Antall', name: 'quantity', type: 'number', noOrderBy: true}
        ]
    };

    constructor(private toastService,
                private Items,
                private $stateParams,
                private $mdDialog) {
    }

    $onInit() {
        this.getItemInventory();
    }

    getItemInventory() {
        this.tableDefinition.settings.promise = this.Items.getItemBalance({itemId: this.$stateParams.itemId}).$promise.then((results) => {
            this.inventory = results;
            this.stockUpdateFunc(_.sumBy(this.inventory, "quantity"));
        }, (error) => {
            this.toastService.parseError(error);
        });
    }

    editFifo(ev, item) {
        this.$mdDialog.show({
            template: '<wms-fifo-dialog item="c.item"></wms-fifo-dialog>',
            targetEvent: ev,
            clickOutsideToClose: false,
            controllerAs: 'c',
            controller: <any>[function () {
                this.item = item;
            }],
        }).then(() => {
            this.getItemInventory();
        });
    };
}

class ItemDetailsInventoryOptions implements ng.IComponentOptions {
    controllerAs = 'c';
    public controller: string = "rkcItemDetailsInventoryController";
    public template: any = require('./itemDetailsInventory.html');
    bindings: any = {
        stockUpdateFunc: '='
    };
}

rkcApp.controller("rkcItemDetailsInventoryController",
    ['toastService', 'Items', '$stateParams', '$mdDialog',
        function (toastService, Items, $stateParams, $mdDialog) {
            return new ItemDetailsInventoryController(toastService, Items, $stateParams, $mdDialog);
        }])
    .component("rkcItemDetailsInventory", new ItemDetailsInventoryOptions());


/** WEBPACK FOOTER **
 ** ./src/app/components/main/views/items/itemDetails/itemDetailsInventory/itemDetailsInventory.ts
 **/